import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../utils/enums";
import useTranslation from "../../hooks/traslation";

const ManageSubadmin = () => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const user = useAuth();

  useEffect(() => {
    if (user?.role === ROLES.SUB_ADMIN) {
      navigate("/permission-denied", { replace: true });
    }
  }, [user]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>{translation.main.manageSubadmin}</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {translation.dashboard.dashboard}
          </span>{" "}
          - {translation.main.manageSubadmin}
        </p>
      </div>

      <div className="cards">
        <SubadminListTopbar setDebouncedSearchTerm={setDebouncedSearchTerm} />
        <SubadminList debouncedSearchTerm={debouncedSearchTerm} />
      </div>
    </MainContainer>
  );
};

export default ManageSubadmin;
